<template>
    <a class="item-button"
       :class="{'item-button--disabled': !enabled}"
       @click.prevent="click">
        <span class="item-button__name">{{ name }}</span>

        <!-- If a search was performed and there are tickets for this event that match the
                        search query, display those ticket names on the button. -->
        <span v-if="highlightItems?.length"
              class="item-button__footer">
            <span v-for="item in highlightItems"
                  :key="item.ID"
                  class="item-button__label">{{ item.name }}</span>
        </span>
        <span v-else
              class="item-button__footer">
            {{ itemCountText }}
        </span>
    </a>
</template>

<script>
import { langPluralFilter } from '@/vue/filters/langFilter';

export default {
    props: {
        searchQuery: {
            type: String,
            default: '',
        },

        highlightItems: {
            type: Array,
            default: null,
        },

        event: {
            type: Object,
            required: true,
        },

        itemCount: {
            type: Number,
            required: true,
        },
    },

    emits: [
        'click',
    ],

    computed: {
        name() {
            return this.event.name;
        },

        enabled() {
            return true;
        },

        itemCountText() {
            return ''
                + this.itemCount
                + ' '
                + langPluralFilter(
                    this.itemCount,
                    'TICKET_BOOKING.TICKET_TYPE'
                );
        },
    },

    methods: {
        click() {
            this.$emit('click');
        },
    },
};
</script>

<!-- .item-button styles are in the ItemPanel component because they are used by both EventButton and ItemButton -->
